import { useEffect, useState } from "react";
import { ArrowDown, ArrowUp, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { fmtPrice } from "./priceUtils";

const FULL = { msrp: "MSRP", reseller: "Reseller", sp: "Service Provider" };
const show = (c) => (c.na ? "N/A" : c.on_request ? "Price on request" : fmtPrice(c.price));

/** Past price changes for one item, limited to the viewer's own price models. */
export function PriceHistoryDialog({ item, as, onClose }) {
  const [h, setH] = useState(null);
  useEffect(() => {
    api.get(`/price-list/history/${item.item_id}`, { params: { as_: as } }).then(({ data }) => setH(data.history))
      .catch(() => setH([]));
  }, [item.item_id, as]);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl" data-testid="price-history-dialog">
        <DialogHeader>
          <DialogTitle>Price history — {item.name}</DialogTitle>
          <DialogDescription>Past changes that took effect, newest first.</DialogDescription>
        </DialogHeader>
        {!h ? <Loader2 className="mx-auto h-5 w-5 animate-spin text-slate-300" />
          : h.length === 0 ? <p className="text-sm text-slate-500">No past price changes.</p> : (
          <table className="w-full text-sm" data-testid="price-history-table">
            <thead><tr className="text-left text-[10px] uppercase tracking-wider text-slate-400">
              <th className="py-1">Effective</th><th>Price model</th><th className="text-right">Before</th><th className="text-right">After</th></tr></thead>
            <tbody>{h.map((r, i) => (
              <tr key={i} className="border-t border-slate-100">
                <td className="py-1.5 tabular-nums">{r.effective_date}</td>
                <td className="text-slate-500">{FULL[r.model]}</td>
                <td className="text-right tabular-nums text-slate-500">{show(r.old)}</td>
                <td className={`text-right tabular-nums font-medium ${r.direction === "up" ? "text-red-600" : r.direction === "down" ? "text-emerald-600" : ""}`}>
                  {r.direction === "up" && <ArrowUp className="inline h-3 w-3" />}{r.direction === "down" && <ArrowDown className="inline h-3 w-3" />}
                  {r.new.price === null && !r.new.na && !r.new.on_request ? "Removed" : show(r.new)}</td>
              </tr>
            ))}</tbody>
          </table>
        )}
      </DialogContent>
    </Dialog>
  );
}
